export default {
  weatherReport: {
    title: "Clima",
    labels: {
      forecastUnavailable: "Pronóstico no disponible",
      unavailableDescription: "No hay pronóstico del clima disponible para este partido.",
      unavailableValue: "N/D",
    },
    empty: {
      title: "No hay reportes del clima disponibles",
    },
  },
};
